import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-view',
  templateUrl: './role-view.component.html',
  styleUrls: ['./role-view.component.css']
})
export class RoleViewComponent {

}
